import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import MasteProfile from "../screens/masters/genericmaster/MasteProfile";

const breadCrumbData = [
  { link: "/masters-list", name: "Masters" },
  { link: "/master-profile", name: "Generic Master" }
];

const Home = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <MasteProfile />
    </LayoutContainer>
  </>
);

export default Home;
